var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.878l-4.228 4.228a.603.603 0 01-.435.177.589.589 0 01-.443-.177.598.598 0 01-.181-.44c0-.171.06-.318.181-.438L9.122 10 4.894 5.772a.604.604 0 01-.177-.435.589.589 0 01.177-.443.598.598 0 01.44-.18c.171 0 .317.06.438.18L10 9.122l4.227-4.228a.604.604 0 01.435-.177.589.589 0 01.443.177c.121.121.182.267.182.44 0 .171-.06.318-.182.438L10.878 10l4.227 4.228c.116.115.175.26.178.435a.589.589 0 01-.178.443.598.598 0 01-.439.18.598.598 0 01-.439-.18L10 10.878z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "assets/static/media/close-white.c237184e.svg";
export { SvgCloseWhite as ReactComponent };